module.exports = __webpack_public_path__ + "img/男-胰腺癌h.6e89a4ef.png";